import { render, staticRenderFns } from "./UpgradePlan.vue?vue&type=template&id=08916cd2&scoped=true"
import script from "./UpgradePlan.vue?vue&type=script&lang=js"
export * from "./UpgradePlan.vue?vue&type=script&lang=js"
import style0 from "./UpgradePlan.vue?vue&type=style&index=0&id=08916cd2&prod&scoped=true&lang=css"
import style1 from "./UpgradePlan.vue?vue&type=style&index=1&id=08916cd2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08916cd2",
  null
  
)

export default component.exports